import React from 'react'
import { Box } from '@mui/material'
import { CheckIcon } from '@heroicons/react/24/solid'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import type { PlatformTourStop } from '../platformTourStops'
import {
  tourListItemCurrentSx,
  tourListItemSx,
  tourStopNumberCurrentSx,
  tourStopNumberDoneSx,
  tourStopNumberUpcomingSx
} from './platformTourStyles'

interface PlatformTourStopListItemProps {
  stop: PlatformTourStop
  position: number
  currentPosition: number
}

/** One stop in the tour's list: ticked once passed, lit while it is the current one. */
export const PlatformTourStopListItem: React.FC<PlatformTourStopListItemProps> = ({
  stop,
  position,
  currentPosition
}) => {
  const { t } = useTranslation()
  const isDone = position < currentPosition
  const isCurrent = position === currentPosition

  return (
    <Box component="li" sx={isCurrent ? tourListItemCurrentSx : tourListItemSx} aria-current={isCurrent && 'step'}>
      {isDone && (
        <Box sx={tourStopNumberDoneSx}>
          <CheckIcon aria-hidden />
        </Box>
      )}
      {isCurrent && <Box sx={tourStopNumberCurrentSx}>{position}</Box>}
      {!isDone && !isCurrent && <Box sx={tourStopNumberUpcomingSx}>{position}</Box>}
      {t(stop.labelKey)}
    </Box>
  )
}
